import { useRef, useEffect, useCallback } from "react";
import * as s from "./Checkbox.style.css";

export interface CheckboxProps {
  checked?: boolean;
  onCheckedChange?: (checked: boolean) => void;
  disabled?: boolean;
  /** Indeterminate state (e.g. "select some" in table header) */
  indeterminate?: boolean;
  "aria-label"?: string;
  className?: string;
  id?: string;
}

export function Checkbox({
  checked = false,
  onCheckedChange,
  disabled,
  indeterminate,
  "aria-label": ariaLabel,
  className,
  id,
}: CheckboxProps) {
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    const el = inputRef.current;
    if (el) el.indeterminate = !!indeterminate;
  }, [indeterminate]);

  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      onCheckedChange?.(e.target.checked);
    },
    [onCheckedChange]
  );

  return (
    <input
      ref={inputRef}
      type="checkbox"
      id={id}
      className={[s.input, className].filter(Boolean).join(" ")}
      checked={checked}
      onChange={handleChange}
      disabled={disabled}
      aria-label={ariaLabel}
      aria-checked={indeterminate ? "mixed" : checked}
    />
  );
}
